import { KeyZone } from '@libs/types/enum'
import { keys, KeyDefine } from './define_keys'
import {
  DefineDevice,
  VirtualHE3SEWireless_24g,
  VirtualHE3SEWireless,
  VirtualMu68_ULTRA,
  VirtualMu68Pro,
  VirtualMu68Pro_Cyan,
  VirtualNa87ProWired,
  VirtualNd63,
  VirtualNd63_Cyan,
  VirtualPolar75,
  VK,
  RoYuanDevice,
  JingTaiMg75Devices,
  JingTaiMer68Devices,
  VirtualHe6Ultra,
  VirtualHe6Ultra_24g,
  JingTaiV2Devices,
  Fe87v2Devices,
  VirtualMer68SESelfDev,
  HuoChaiRenDevices,
  VirtualFE87V2_MuYan,
} from './define'
import { KeyZoneData } from '@libs/types/response'

export const KeysInZone = (): VK[] => {
  const zoneKeys: VK[] = []
  keys.forEach((value) => {
    if (value.Zone !== undefined) {
      zoneKeys.push(value.VirtualKey)
    }
  })
  return zoneKeys
}

export const KeysZones = (): Map<VK, KeyZoneData> => {
  const kz = new Map<VK, KeyZoneData>()
  keys.forEach((value, index) => {
    if (value.Zone !== undefined) {
      kz.set(value.VirtualKey, {
        Zone: GetKeyZones(value),
        Order: index,
      })
    }
  })
  return kz
}
const he6UltraKeysNotInZone: VK[] = [0x9a, 0x9b, 0x9c, 0x9d, 0x9e, 0x9f, 0x89, 0x8a] as VK[]
const JingTaiKeysNotInZone: VK[] = [0xab, 0xa9, 0xfa, 0x98, 0x99, 0x9a, 0x9b, 0x05, 0x06] as VK[]
const fe87v2KeysNotInZone: VK[] = [0x05, 0x06, 0x98, 0x99, 0x9a, 0x9b, 0x61, 0x62, 0x63, 0x64, 0x65, 0x66, 0x67, 0xfa, 0x68, 0x69, 0x60, 0x90, 0x6f, 0x6a, 0x6d, 0x6b, 0xfd, 0x6e, 0x5c] as VK[]
const huochairenKeysNotInZone: VK[] = [0x98, 0x99, 0x9a, 0x9b, 0x9c, 0x9d, 0x9e, 0x9f, 0x89, 0x8a, 0xfa] as VK[]
export const KeysNotInZone = new Map<DefineDevice, VK[]>([
  [VirtualHE3SEWireless_24g, [0x98, 0x99, 0x9a, 0x9b, 0xfa] as VK[]],
  [VirtualHE3SEWireless, [0x98, 0x99, 0x9a, 0x9b, 0xfa] as VK[]],

  [VirtualMu68Pro, JingTaiKeysNotInZone],
  [VirtualNd63, JingTaiKeysNotInZone],
  [VirtualMu68Pro_Cyan, JingTaiKeysNotInZone],
  [VirtualMu68_ULTRA, JingTaiKeysNotInZone],
  [VirtualPolar75, JingTaiKeysNotInZone],
  [VirtualNd63_Cyan, JingTaiKeysNotInZone],
  [VirtualNa87ProWired, JingTaiKeysNotInZone],

  [VirtualHe6Ultra, he6UltraKeysNotInZone],
  [VirtualHe6Ultra_24g, he6UltraKeysNotInZone],
  [VirtualMer68SESelfDev, fe87v2KeysNotInZone],
  [VirtualFE87V2_MuYan, [0x98, 0x99, 0x9a, 0x9b, 0x9c, 0x9d, 0x9e, 0x9f, 0x89, 0x8a, 0xfa] as VK[]],
])
;[...JingTaiMg75Devices, ...JingTaiMer68Devices].forEach((value) => KeysNotInZone.set(value, JingTaiKeysNotInZone))

RoYuanDevice.forEach((value) => {
  KeysNotInZone.set(value, [0x98, 0x99, 0x9a, 0x9b, 0x9e, 0x9f, 0x89, 0x8a] as VK[])
})

JingTaiV2Devices.forEach((value) => {
  KeysNotInZone.set(value, [0x98, 0x99, 0x9a, 0x9b] as VK[])
})

Fe87v2Devices.forEach((value) => {
  KeysNotInZone.set(value, fe87v2KeysNotInZone)
})
HuoChaiRenDevices.forEach((value) => {
  KeysNotInZone.set(value, huochairenKeysNotInZone)
})

// const GetKeyZone = (key: KeyDefine): KeyZone => {
//     const zones = key.Zone
//     if (!zones) throw new Error("KeyDefine Zone is not defined");
//     if (zones & KeyZone.normalKey) return KeyZone.normalKey
//     if (zones & KeyZone.extendKey) return KeyZone.extendKey
//     if (zones & KeyZone.media) return KeyZone.media
//     if (zones & KeyZone.mouse) return KeyZone.mouse
//     if (zones & KeyZone.modifierKey) return KeyZone.modifierKey
//     throw new Error("KeyDefine Zone is not defined");
// }

const GetKeyZones = (key: KeyDefine): KeyZone[] => {
  const zones = key.Zone
  if (!zones) return []
  const res: KeyZone[] = []
  if (zones & KeyZone.normalKey) res.push(KeyZone.normalKey)
  if (zones & KeyZone.extendKey) res.push(KeyZone.extendKey)
  if (zones & KeyZone.media) res.push(KeyZone.media)
  if (zones & KeyZone.mouse) res.push(KeyZone.mouse)
  if (zones & KeyZone.modifierKey) res.push(KeyZone.modifierKey)
  return res
}
